import { render, staticRenderFns } from "./EnglishNews.vue?vue&type=template&id=2551b260&scoped=true&"
import script from "./EnglishNews.vue?vue&type=script&lang=js&"
export * from "./EnglishNews.vue?vue&type=script&lang=js&"
import style0 from "./EnglishNews.vue?vue&type=style&index=0&id=2551b260&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2551b260",
  null
  
)

export default component.exports